import { ActivityLogRole, ActivityLogStatus } from "./iActivityLogEntry";

export type RoleFilterKey = ActivityLogRole | "unknown";

export const ALL_AREAS = "all";

export default interface IActivityLogFilter {
  start: string;
  end: string;
  roles: Record<RoleFilterKey, boolean>;
  area: string;
  status: "all" | ActivityLogStatus;
  search: string;
}
